<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="姓名：" v-if="isAll">
            <el-input clearable v-model="filterForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <!-- <el-form-item label="电话：">
            <el-input clearable v-model="filterForm.phone" placeholder="请输入电话"></el-input>
          </el-form-item> -->
          <el-form-item label="身份证：">
            <el-input clearable v-model="filterForm.idCard" placeholder="请输入身份证" :disabled="!isAll"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <el-button type="success" icon="el-icon-download" @click="$refs.DownloadByArea.visible=true">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2"
      labelWidth="240px" />
      <!-- dialogWidth="1000px" -->

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler"
      :isShowArea="true" />
      <!-- @watchChange="watchChange"
      dialogWidth="1000px" -->

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" />
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
import { publicData2 } from '@/publicData/index'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'canjiren_jynldwjycjrzkdcb',
      dialogTitle: '就业年龄段未就业残疾人状况调查表',
      // fileName: 'qiyexinxi',
      xlsCode: '62',
      importTipKey: 'idCard',
      importTiplabel: '身份证号码',

      baseInfo: [
        { key: 'province', label: '省', fixed: true },
        { key: 'city', label: '市', fixed: true },
        { key: 'county', label: '县', fixed: true },
        { key: 'town', label: '镇', fixed: true },
        { key: 'village', label: '村', fixed: true },
        // { key: 'areaName', label: '地区', fixed: true },

        { key: 'name', label: '姓名', fixed: true },
        // { key: 'phone', label: '电话', fixed: true },
        { key: 'idCard', label: '身份证号码', fixed: true },
        { key: 'six', label: '性别' },
        { key: 'nation', label: '民族' },
        { key: 'birthDayTime_', label: '出生年月日' },
        { key: 'education', label: '文化程度' },
        { key: 'major', label: '专业' },
        { key: 'graduationTime_', label: '毕业时间' },
        { key: 'deformedType', label: '残疾类别' },
        { key: 'deformedLevel', label: '残疾等级' },
      ],
      watchChangeKey: [
        // 'buyType'
      ],
      defaultKeyValue: {
        // buyType: 1
      },
      // userList: [],
    }
  },
  computed: {
    importAction() {
      // return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
      return this.$api.baseUrl + this.$api.url_import(this.sign)
    },
    formItems() {
      return [
        { type: 'text', key: 'name', label: '姓名' },
        { type: 'select_s', key: 'six', label: '性别', options: ['男','女']},
        { type: 'select_s', key: 'nation', label: '民族', options: publicData2.nation },
        { type: 'text', key: 'idCard', label: '身份证号码' },
        { type: 'date', key: 'birthDayTime', label: '出生年月日' },
        { type: 'select_s', key: 'education', label: '文化程度', options: this.$fuwuData.education_ },
        { type: 'text', key: 'major', label: '专业' },
        { type: 'date', key: 'graduationTime', label: '毕业时间' },
        { type: 'text', key: 'deformedType', label: '残疾类别' },
        { type: 'text', key: 'deformedLevel', label: '残疾等级' },
        { type: 'select_s', key: 'lifeCapacity', label: '有无生活自理能力', options: ['是','否'] },
        { type: 'select_s', key: 'laborCapacity', label: '有无劳动能力', options: ['是','否'] },
        { type: 'text', key: 'deformedId', label: '残疾证件号' },
        { type: 'text', key: 'phone', label: '本人/联系人电话' },
        { type: 'text', key: 'liveAddress', label: '被调查人居住地址' },
        { type: 'text', key: 'bornAddress', label: '户口所在地' },
        { type: 'date', key: 'jobTime', label: '就业时间' },
        { type: 'text', key: 'jobAddress', label: '就业地点' },
        { type: 'text', key: 'jobOrganization', label: '就业单位' },
        { type: 'text', key: 'jobType', label: '从事工种' },
        { type: 'select_s', key: 'jobStyle', label: '就业方式', options: this.$public.jiuYeXS },
        { type: 'select_s', key: 'jobArea', label: '就业区域', options: this.$fuwuData.jobArea },
      ]
    },
    formItems2() {
      return [
        { type: 'select_s', key: 'jobWish', label: '是否有就业意愿', options: ['是','否'] },
        { type: 'textarea', key: 'noWorkReason', label: '无就业意愿的原因' },
        { type: 'text', key: 'jobWishDomain', label: '从事行业意向' },
        { type: 'select_s', key: 'setUpWith', label: '是否有创业意向', options: ['是','否'] },
        { type: 'text', key: 'setUpDomain', label: '创业方向' },
        { type: 'select_s', key: 'skillTraining', label: '是否已参加技能培训', options: ['是','否'] },
        { type: 'text', key: 'trainingDomain', label: '培训工种' },
        { type: 'date', key: 'trainingTime', label: '培训时间' },
        { type: 'select_s', key: 'skillTrainingWish', label: '是否有意向参加技能培训', options: ['是','否'] },
        { type: 'text', key: 'skillTrainingWishDomain', label: '意愿培训工种' },
        { type: 'date', key: 'trainWishTime', label: '意愿培训时间' },
        { type: 'textarea', key: 'jobWishAddress_1', label: '第一意愿，就业意向地' },
        { type: 'text', key: 'jobWishSalary_1', label: '第一意愿，期望月薪（元）' },
        { type: 'text', key: 'jobWishDomain_1', label: '第一意愿，意向岗位（工种）' },
        { type: 'textarea', key: 'jobWishAddress_2', label: '第二意愿，就业意向地' },
        { type: 'text', key: 'jobWishSalary_2', label: '第二意愿，期望月薪（元）' },
        { type: 'text', key: 'jobWishDomain_2', label: '第二意愿，意向岗位（工种）' },
        { type: 'textarea', key: 'jobWishAddress_3', label: '第三意愿，就业意向地' },
        { type: 'text', key: 'jobWishSalary_3', label: '第三意愿，期望月薪（元）' },
        { type: 'text', key: 'jobWishDomain_3', label: '第三意愿，意向岗位（工种）' },
        { type: 'textarea', key: 'remarks', label: '备注' },
      ]
    }
  },
  methods: {
    // modifyHandlerBefore() {
      //   let {
      //     user
      //   } = this.selectData
      //   console.log(user.u_idCard)
      //   this.userList = [
      //     {
      //       label: user.u_idCard,
      //       value: user.id,
      //     }
      //   ]
      // },
    // watchChange(data) {
      //   console.log(`%caaaa:`, 'color: #f00;', data)
      //   switch (data.key) {
      //     case 'buyType':
      //       if (data.val === 1) {
      //         this.formItems.splice(8, 1)
      //       } else if (data.val === 2) {
      //         this.formItems.splice(8, 1, { type: 'text', key: 'cash', label: '垫付金额' })
      //       }
      //       break;
      //   }
      // },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let rData = {}
      let {
        id, province, city, county, town, village, 
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        name,
        six,
        nation,
        idCard,
        birthDayTime,
        education,
        major,
        graduationTime,
        deformedType,
        deformedLevel,
        lifeCapacity,
        laborCapacity,
        deformedId,
        phone,
        liveAddress,
        bornAddress,
        jobTime,
        jobAddress,
        jobOrganization,
        jobType,
        jobStyle,
        jobArea,
        jobWish,
        noWorkReason,
        jobWishDomain,
        setUpWith,
        setUpDomain,
        skillTraining,
        trainingDomain,
        trainingTime,
        skillTrainingWish,
        skillTrainingWishDomain,
        trainWishTime,
        jobWishAddress_1,
        jobWishSalary_1,
        jobWishDomain_1,
        jobWishAddress_2,
        jobWishSalary_2,
        jobWishDomain_2,
        jobWishAddress_3,
        jobWishSalary_3,
        jobWishDomain_3,
        remarks,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      } = result
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      

      if (!province) { this.$message.warning('请选择地区') }
      else if (!name) { this.$message.warning('请填写姓名') }
      else if (!idCard) { this.$message.warning('请填写身份证号码') }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      else if (this.isCreate) {
        rData = {
          province, city, county, town, village,
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          name,
          six,
          nation,
          idCard,
          birthDayTime,
          education,
          major,
          graduationTime,
          deformedType,
          deformedLevel,
          lifeCapacity,
          laborCapacity,
          deformedId,
          phone,
          liveAddress,
          bornAddress,
          jobTime,
          jobAddress,
          jobOrganization,
          jobType,
          jobStyle,
          jobArea,
          jobWish,
          noWorkReason,
          jobWishDomain,
          setUpWith,
          setUpDomain,
          skillTraining,
          trainingDomain,
          trainingTime,
          skillTrainingWish,
          skillTrainingWishDomain,
          trainWishTime,
          jobWishAddress_1,
          jobWishSalary_1,
          jobWishDomain_1,
          jobWishAddress_2,
          jobWishSalary_2,
          jobWishDomain_2,
          jobWishAddress_3,
          jobWishSalary_3,
          jobWishDomain_3,
          remarks,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        }
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        const mapList_must = ['province', 'city', 'county', 'town', 'village']
        mapList_must.forEach(x => {
          rData[x] = result[x]
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        const mapList = [
          'name',
          'six',
          'nation',
          'idCard',
          'birthDayTime',
          'education',
          'major',
          'graduationTime',
          'deformedType',
          'deformedLevel',
          'lifeCapacity',
          'laborCapacity',
          'deformedId',
          'phone',
          'liveAddress',
          'bornAddress',
          'jobTime',
          'jobAddress',
          'jobOrganization',
          'jobType',
          'jobStyle',
          'jobArea',
          'jobWish',
          'noWorkReason',
          'jobWishDomain',
          'setUpWith',
          'setUpDomain',
          'skillTraining',
          'trainingDomain',
          'trainingTime',
          'skillTrainingWish',
          'skillTrainingWishDomain',
          'trainWishTime',
          'jobWishAddress_1',
          'jobWishSalary_1',
          'jobWishDomain_1',
          'jobWishAddress_2',
          'jobWishSalary_2',
          'jobWishDomain_2',
          'jobWishAddress_3',
          'jobWishSalary_3',
          'jobWishDomain_3',
          'remarks',
        ]
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        // rData.userId = this.selectData.userId
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          // this.tableData = _R
          this.tableData = _R.map(x => {
            x.birthDayTime_ = x.birthDayTime
            x.birthDayTime = new Date(x.birthDayTime_).getTime()
            x.graduationTime_ = x.graduationTime
            x.graduationTime = new Date(x.graduationTime_).getTime()
            x.jobTime_ = x.jobTime
            x.jobTime = new Date(x.jobTime_).getTime()
            x.trainingTime_ = x.trainingTime
            x.trainingTime = new Date(x.trainingTime_).getTime()
            x.trainWishTime_ = x.trainWishTime
            x.trainWishTime = new Date(x.trainWishTime_).getTime()
            return x
          })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    const powerStr = powerMap[this.sign]
    // console.log(powerStr)
    this.btnShow.search = true
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    // const mapList = ['search','create','modify','delete','import','export']
    const mapList = ['create','modify','delete','import','export']
    if (this.userInfo.admin) {
      this.isAll = true
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        } else if (!x) {
          this.btnShow.search = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}





.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>